import { Component, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { LogDto, MceApiService } from '../../../core/mceapi.client.generated';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-logs',
  imports: [MatCardModule,MatListModule, DatePipe, MatIconModule],
  templateUrl: './logs.component.html',
  styles: ``,
})
export class LogsComponent {
  private mceApiService = inject(MceApiService);

  webjobLogsRx = rxResource({
    params: () => ({}),
    stream: () => this.mceApiService.v1SiteSettingsLogs(20)
  });
  webjobLogs = computed(() => this.webjobLogsRx.value() ?? []);


  trackByLog = (_index: number, log: LogDto): string =>
    `${log.createdAt?.value ?? ''}-${log.type?.value ?? ''}-${log.name ?? ''}-${log.details ?? ''}`;
}
